import { render, staticRenderFns } from "./InternalLink.vue?vue&type=template&id=af02c10a&"
import script from "./InternalLink.vue?vue&type=script&lang=ts&"
export * from "./InternalLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports